import React, { useEffect, useState } from 'react';
import BreadcrumbBack from '../../../components/breadcrumb/BreadcrumbBack';
import CustomButton from '../../../components/button/CustomButton';
import { useNavigate, useParams } from 'react-router-dom';
import {
  deleteEmptyAdminBatchStudents,
  deleteMultipleAdminBatchStudents,
  getAllBatchStudents,
  getCourseExcludeFromBatch,
  showAdminBatch,
} from '../../../service/admin/adminBatch.service';
import PaginationDataGrid from '../../../components/tables/PaginationDataGrid';
import TableButton from '../../../components/button/TableButton';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import Models from '../../../components/models/Models';
import AdminStudentCE from '../students/AdminStudentCE';
import { CSVDownload } from '../../../helpers/FileDownloader';
import { StudentSampleData } from '../../../helpers/sampleData';
import ExcelUpload from '../../../components/uploads/ExcelUpload';
import { generateRandomString } from '../../../helpers/commonHelper';
import moment from 'moment';
import { Helmet } from 'react-helmet-async';

export default function AdminBatchStudents() {
  const [pageLoad, setpageLoad] = useState(false);
  const [loading, setLoading] = useState(false);
  const [batchData, setBatchData] = useState<any>();
  const [refresh, setRefresh] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [sampleModel, setSampleModel] = useState(false);
  const [open, setOpen] = useState(false);
  const [openUpload, setOpenUpload] = useState(false);
  const [removeStudentsModel, setRemoveStudentsModel] = useState(false);
  const id: any = useParams();
  const navigate = useNavigate();

  const fetchBatchData = async (id: string) => {
    const get: any = await showAdminBatch(id);
    console.log(get);
    if (get?.status === 'success') {
      setBatchData(get?.message);
    }
  };
  useEffect(() => {
    fetchBatchData(id?.id);
  }, []);
  const handleItems = (data: any) => {
    if (data.length > 0) {
      setSelectedRow(data);
    } else {
      setSelectedRow([]);
    }
  };
  const handleMultipleDelete = () => {
    if (selectedRow.length > 0) {
      Swal.fire({
        title: 'Are you sure want to remove all selected students?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then(async (result) => {
        if (result.isConfirmed) {
          const del: any = await deleteMultipleAdminBatchStudents(
            id.id,
            selectedRow
          );
          if (del.status === 'success') {
            setRefresh(!refresh);
            setSelectedRow([]);
            toast.success(del.message);
          }
        }
      });
    } else {
      toast.error('Please Select  student');
    }
  };
  const handleEmptyBatch = async () => {
    if (selectedRow.length > 0) {
      Swal.fire({
        title: 'Are you sure want to remove all students  from this batch?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then(async (result) => {
        if (result.isConfirmed) {
          const del: any = await deleteEmptyAdminBatchStudents(id.id);
          if (del.status === 'success') {
            setRefresh(!refresh);
            setSelectedRow([]);
            toast.success(del.message);
          }
        }
      });
    } else {
      toast.error('Please Select  student');
    }
  };

  const handleSampleDownload = () => {
    let data = [];
    for (let i = 0; i <= 5; i++) {
      data.push({
        S_no: i + 1,
        Name: generateRandomString(8, false),
        Phone: generateRandomString(10, true),
        Email: i + generateRandomString(5, false)+'@demo.in',
        DOB: '2002-12-12',
        Gender: 'Male',
        Validaty:moment().add(generateRandomString(2, true), 'days').format('YYYY-MM-DD'),
        Course_amount:generateRandomString(3, true),
        EMI:Math.random() < 0.5 ? true : false
      });
    }
    CSVDownload('student-sample-download', data);
  };
   const handleSampleRemoveStudent = () => {
    let data = [];
    for (let i = 0; i <= 5; i++) {
      data.push({
        S_no: i + 1,
        Email: i + generateRandomString(5, false)+'@demo.in',
      });
    }
    CSVDownload('remove-student-sample-download', data);
  };
  const handleFileUpload = () => {
    setOpenUpload(!openUpload);
  };
  const handleDownload = async () => {
    let get: any = await getAllBatchStudents(id.id);
    if (get?.status === 'success') {
      if (get?.message.length > 0) {
        let newData: any = [];
        get?.message.map((e: any, i: number) => {
          newData.push({
            'S No': i + 1,
            Name: e.student.name,
            Email: e.student.email,
            Phone: e.student.phone,
            DOB: moment(e.student.dob).format('YYYY-MM-DD'),
            Gender: e.student?.gender?.name,
          });
        });
        CSVDownload(`${batchData?.name}'s students`, newData);
      } else {
        return toast.error('No students found for download');
      }
    }
  };
  const handleCourseAccess = async()=>{
    let courses:any = []
    let fetch:any = await getCourseExcludeFromBatch(id?.id);
    if(fetch?.status === "success"){
      fetch?.message.map((e:any)=>{
        if(e.batchCourses.length !== 0){
          courses.push({
            id:e.id,
            name:e.name,
            url:`admin/batches/courses/access/${e.id}/${id?.id}`
          })
        }
      })

    } 
   
    
    Swal.fire({
      title: "Select Course",
      width: 600,
      html: `
        <div id="course-buttons" style="display: flex; flex-wrap: wrap; justify-content: start;">
          ${courses.map((course:any) => `
            <button data-tooltip="view access" class="swal2-styled course-btn border rounded-lg bg-gray-300" data-url=${`/admin/batches/courses/access/${course.id}/${id?.id}?name=${encodeURIComponent(course.name)}`} style="margin: 5px;">
              ${course.name}
            </button>
          `).join("")}
        </div>
      `,
      showConfirmButton: false, // no OK button
      didOpen: () => {
        document.querySelectorAll('.course-btn').forEach(btn => {
          btn.addEventListener('click', () => {
            console.log("test1213");
            const url = btn.getAttribute('data-url');
            if (url) {
              Swal.close();        // 👈 closes the modal first
              navigate(url);       // 👈 then navigates
            }
          });
        });
      }
    });
  }
  const handleStudentCourseAccess = async()=>{

  }
  const handleRemoveStudentsModel = async() => {
    setRemoveStudentsModel(!removeStudentsModel);
  }
  return (
    <>
      <Helmet>
        <title>{`Batch Students | ${window.location.hostname}`}</title>
      </Helmet>
      <BreadcrumbBack title={`${batchData?.name}'s Students`}>
        <CustomButton
          title="Browse Students"
          onClick={() => navigate(`/admin/batches/students/add/${id?.id}`)}
          icon={true}
          iconName="create"
        />
        <CustomButton
          onClick={() => setOpen(!open)}
          title="Add New Student"
          icon={true}
          iconName="create"
          bg="bg-purple-800"
        />
        {selectedRow.length > 0 ? (
          <>
            <CustomButton
              onClick={handleMultipleDelete}
              title="Delete Students"
              icon={true}
              iconName="delete"
              bg="bg-red-600"
            />
            <CustomButton
              onClick={handleEmptyBatch}
              title="Empty Batch"
              icon={true}
              iconName="delete"
              bg="bg-red-600"
            />
          </>
        ) : null}
      </BreadcrumbBack>
      <div className="my-2">
        <div className="my-2 'p-4 dark:bg-dark-purple1  gap-5  rounded-lg flex flex-wrap flex-row sm:flex-row md:flex-row lg:items-center justify-between lg:ml-5">
          <div className="gap-2 flex flex-row  flex-wrap justify-end mr-5  ">
            <TableButton
              onClick={handleDownload}
              icon={true}
              title="download"
              text="All Student"
              toottip="Download Excel"
            />
            <TableButton
              onClick={handleFileUpload}
              text="Upload Student"
              icon={true}
              title="upload"
              toottip="Upload Excel"
            />
            <TableButton
              onClick={(()=> setSampleModel(!sampleModel))}
              text="Download Sample"
              icon={true}
              title="excel"
              toottip="Download Sample Excel"
            />
             <TableButton
              onClick={handleRemoveStudentsModel}
              text="Remove Students"
              icon={true}
              title="delete"
              toottip="Remove Students"
            />
          </div>
          <div className='gap-2 flex flex-row  flex-wrap justify-end mr-5'>
          <TableButton
              onClick={handleCourseAccess}
              text="Batch Course Access"
              icon={true}
              title="course"
              toottip="course access"
            />
            
          </div>
        </div>
        <PaginationDataGrid
          name="AdminbatchStudents"
          refresh={refresh}
          onSubmit={handleItems}
          checkbox={true}
          id={id.id}
        />
      </div>
      <Models name="Create New Student " isOpen={open} isClose={setOpen}>
        <AdminStudentCE type="create" batchId={id?.id} isOpen={setOpen} />
      </Models>
      <Models
        name="Upload Batch Student"
        isOpen={openUpload}
        isClose={setOpenUpload}
      >
        <ExcelUpload
          name="AdminBatchStudentUpload"
          accept=".csv"
          data={id}
          open={setOpenUpload}
        />
      </Models>
       <Models
        name="Remove Students from Batch"
        isOpen={removeStudentsModel}
        isClose={setRemoveStudentsModel}
      >
        <ExcelUpload
          name="AdminBatchStudentRemove"
          accept=".csv"
          data={id}
          open={setRemoveStudentsModel}
        />
      </Models>
      <Models
        name="Samples"
        isOpen={sampleModel}
        isClose={setSampleModel}
      >
       <div className='flex flex-col gap-3' >
        <TableButton
              onClick={handleSampleDownload}
              text="Download Student Upload Sample"
              icon={true}
              title="excel"
              toottip="Download Student Upload Sample"
            />
              <TableButton
              onClick={handleSampleRemoveStudent}
              text="Download Remove Student from Batch Sample"
              icon={true}
              title="delete"
              bg="bg-red-600"
              toottip="Download Remove Student from Batch Sample"
            />
       </div>
      </Models>
    </>
  );
}
